import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-sans py-8 pb-4 px-4"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col space-y-3"
}
const _hoisted_3 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_4 = {
  key: 1,
  class: "animate-spin h-5 w-5 m-auto text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_5 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_6 = {
  key: 1,
  class: "animate-spin h-5 w-5 m-auto text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col space-y-3"
}
const _hoisted_8 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_9 = {
  key: 1,
  class: "animate-spin h-5 w-5 m-auto text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col space-y-3"
}
const _hoisted_11 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_12 = {
  key: 1,
  class: "animate-spin h-5 w-5 m-auto text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import {computed, onMounted, PropType, ref} from 'vue';
import ApiService from "@/services/api/apiService";

import {EventInterface} from "@/interfaces/EventInterface";
import {alertController, modalController, toastController} from "@ionic/vue";
import InputTextarea from "@/components/InputTextarea.vue";
import * as events from "events";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";


export default /*@__PURE__*/_defineComponent({
  __name: 'EventInviteRequestContextMenu',
  props: {
  event: {
    type: Object as PropType<EventInterface>,
    required: true
  },
  user: {
    type: Object as PropType<UserBasicInformationInterface>,
    required: true
  }
},
  setup(__props) {


const loading = ref(true)

const props = __props

const authUser = ref()
const isRejection = ref(false)
const rejectionReason = ref('')

const showRejection = async () => {
  isRejection.value = true
}

const hideRejection = async () => {
  isRejection.value = false
}

onMounted(async () => {
  authUser.value = await ApiService.User().authUser()
  loading.value = false
})

const confirmRejection = async () => {

  await modalController.dismiss()

  try {
    await ApiService.Events().rejectInvite(props.event?.id, props.user?.id, rejectionReason.value)
    Observable.emit(ObservableEvent.PendingEventResponsesChanged)
    Observable.emit(ObservableEvent.PullToRefreshMyEvents)
    Observable.emit(ObservableEvent.PullToRefreshMyTickets)
    Observable.emit(ObservableEvent.EventsChanged)
  } catch (e: any) {
    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }

}


const acceptRequest = async () => {

  await modalController.dismiss()

  try {
    await ApiService.Events().confirmInvite(props.event?.id, props.user?.id)
    Observable.emit(ObservableEvent.PendingEventResponsesChanged)
    Observable.emit(ObservableEvent.PullToRefreshMyEvents)
    Observable.emit(ObservableEvent.PullToRefreshMyTickets)
    Observable.emit(ObservableEvent.EventsChanged)
  } catch (e: any) {
    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }


}

const isAttending = computed(() => {
  return props.event?.attending.find((user) => user.id === props.user?.id)
})

const removeFromEvent = async () => {

  const alert = await alertController.create({
    header: 'Remove',
    message: `Are you sure you want to remove this user from the guest list?`,
    buttons: [
      {
        text: 'Cancel',
        handler: async () => {
          await alertController.dismiss()
          await modalController.dismiss()
        }
      },
      {
        text: 'Yes',
        role: 'destructive',
        handler:  async () => {

          await alertController.dismiss()
          await modalController.dismiss()

          try {
            await ApiService.Events().deleteAttendanceRecord(props.event?.id, props.user?.id)
            Observable.emit(ObservableEvent.PendingEventResponsesChanged)
            Observable.emit(ObservableEvent.PullToRefreshMyEvents)
            Observable.emit(ObservableEvent.PullToRefreshMyTickets)
            Observable.emit(ObservableEvent.EventsChanged)
          } catch (e:any) {
            const toast = await toastController.create({
              message: e.data.message,
              duration: 3000,
              position: 'bottom',
              color: 'danger'
            });
            await toast.present();
          }

        }
      },
    ]
  })
  await alert.present()

}


return (_ctx: any,_cache: any) => {
  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!isAttending.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (!isRejection.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", {
                      onClick: showRejection,
                      class: "border-2 border-brand-darkish-gray font-medium rounded-full text-brand-light-gray px-5 h-12 flex flex-grow"
                    }, [
                      true
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Reject"))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }, null, -1),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            }, null, -1)
                          ]))]))
                    ]),
                    _createElementVNode("div", {
                      onClick: acceptRequest,
                      class: "border-2 border-white bg-white font-medium rounded-full text-brand-black px-5 h-12 flex flex-grow"
                    }, [
                      true
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Accept"))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }, null, -1),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            }, null, -1)
                          ]))]))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (isRejection.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(InputTextarea, {
                      modelValue: rejectionReason.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rejectionReason).value = $event)),
                      placeholder: "Please provide a reason for why you're rejecting this invite request...",
                      enterkeyhint: "next"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", {
                      onClick: confirmRejection,
                      class: "border-2 border-red-500 bg-red-500 font-medium rounded-full text-white px-5 h-12 flex flex-grow"
                    }, [
                      true
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Confirm rejection"))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }, null, -1),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            }, null, -1)
                          ]))]))
                    ]),
                    _createElementVNode("div", {
                      onClick: hideRejection,
                      class: "pb-3 pt-2 text-brand-light-gray w-full text-center"
                    }, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("span", { class: "border-b pb-1" }, "Cancel", -1)
                    ]))])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (isAttending.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", {
                onClick: removeFromEvent,
                class: "border-2 border-red-500 bg-red-500 font-medium rounded-full text-white px-5 h-12 flex flex-grow"
              }, [
                true
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Remove from guest list"))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }, null, -1)
                    ]))]))
              ])
            ]))
          : _createCommentVNode("", true),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "safe-area-bottom" }, null, -1))
      ]))
    : _createCommentVNode("", true)
}
}

})